import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Protocol17025CatService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<Protocol17025Cat_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Cat?token="+Token).pipe(
      map(data=>{
        return data as Array<Protocol17025Cat_Interface>
      })
    )
  }

  AddEdit(model: Protocol17025Cat_Interface,Token:String):Observable<Protocol17025Cat_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      parent:model.parent,
      token:Token
    }


    return this.http.post(environment.BaseUrl + "Daro/Protocol17025Cat/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as Protocol17025Cat_Interface
        })
    )

  }

  Delete(Id: number,
    Type: number,
    Token:String): Observable<Array<Protocol17025Cat_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Protocol17025Cat/Delete?token=" + Token +
      "&id="+Id +
      "&Type=" + Type).pipe(
      map(data=>{
        return data as Array<Protocol17025Cat_Interface>
      })
    )
  }

}
